import { render, staticRenderFns } from "./GofixMainElement.vue?vue&type=template&id=340c0fde&"
import script from "./GofixMainElement.vue?vue&type=script&lang=js&"
export * from "./GofixMainElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports